import enUS from './en-US';
import zhCN from './zh-CN';

export default {
    messages: {
        'en-US': enUS,
        'zh-CN': zhCN,
    },
};
